import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  reasonText = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    title: string;
    text: string;
    subText: string;
    hideCancel?: boolean;
    showReasonInput?: boolean;
    reasonLabel?: string;
    reasonMinLength?: number;
    reasonMaxLength?: number;
  }) {}
}
